import React, { useState, useEffect, useRef } from "react";
import { getGallery } from "../../contentful";
import "./ImageGridStyles.scss";
import { FaArrowAltCircleLeft, FaArrowAltCircleRight, FaDownload, FaTimesCircle } from "react-icons/fa";

const ImageGrid = (props) => {
  const [images, setImages] = useState(null);
  const [bigImage, setBigImage] = useState(null);
  const dialogRef = useRef(null);

  useEffect(() => {
    getGallery().then((data) => setImages(data));
  }, []);

  const openDialog = (index) => {
    if (dialogRef.current && dialogRef.current.showModal) {
      dialogRef.current.showModal();
      setBigImage(index);
    }
  };

  const closeDialog = () => {
    if (dialogRef.current && dialogRef.current.close) {
      dialogRef.current.close();
    }
  };

  const handleNext = () => {
    if (bigImage < images.length - 1) return setBigImage((prev) => prev + 1);
    return setBigImage(0);
  };
  const handlePrev = () => {
    if (bigImage > 0) return setBigImage((prev) => prev - 1);
    return setBigImage(images.length - 1);
  };

  return (
    <>
      <div className='image-grid'>
        {images &&
          images.map((image, index) => (
            <div
              key={image.fields.image.fields.file.url}
              onClick={() => openDialog(index)}
              className='image-grid__image-container'
            >
              <img src={image.fields.image.fields.file.url} alt='uploaded pic' />
              <a download href={image.fields.image.fields.file.url} target='_blank'>
                <FaDownload size={30} color='steelblue' />
              </a>
            </div>
          ))}
      </div>
      <dialog ref={dialogRef} className='image-grid__viewer'>
        <button className='image-grid__viewer-close' onClick={closeDialog}>
          <FaTimesCircle />
        </button>
        <img key={bigImage} src={images?.[bigImage]?.fields?.image?.fields?.file?.url} />
        <div className='image-grid__chevrons'>
          <button onClick={handlePrev}>
            <FaArrowAltCircleLeft />
          </button>
          <button onClick={handleNext}>
            <FaArrowAltCircleRight />
          </button>
        </div>
      </dialog>
    </>
  );
};

export default ImageGrid;
